import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types'
import { BrowserRouter as Router, Link } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { jwtDecode } from 'jwt-decode'; // Corrected import


export default function Header(props) {
    const [isOpen, setIsOpen] = useState(false);
    const [isLoggedIn, setIsLoggedIn] = useState(false);

    useEffect(() => {
        const token = localStorage.getItem('authToken');
        if (token) {
            try {
                jwtDecode(token); // Decode the token to verify it's valid
                setIsLoggedIn(true);
            } catch (error) {
                console.error('Invalid token:', error);
                setIsLoggedIn(false);
            }
        } else {
            setIsLoggedIn(false);
        }

    }, []);

    const handleLogout = () => {
        localStorage.removeItem('authToken'); // Remove token
        localStorage.removeItem('refreshToken'); // Remove refresh token if you're storing it
        setIsLoggedIn(false); // Update the login state
        window.location.reload(); // Reload to reflect changes in the UI
    };

    const [display, setDisplay] = useState('block');  // Initial display state is 'block'

    // Function to handle closing the download box
    const handleClose = () => {
        setDisplay('none');  // Set display to 'none', hiding the div
    };
    return (
        <>
            <div className="page-loader">
                <div className="spinner"></div>
            </div>
            <div id='downloadbox' style={{ display: display }}>
                <div className='flex gap-4 justify-between items-center shadow border-b w-full px-5 py-2 md:hidden'>
                    <div>
                        <button className='p-1 mr-3 text-[#B3902D]' id='closedownloadbox'  onClick={handleClose}><i className="fa-regular fa-xmark"></i></button> 
                        <span className='font-semibold text-lg'>JWLBOOK APP</span>
                    </div>
                    <div>
                        <Link to="#" className="px-5 py-1 bg-[#B3902D] rounded-full font-medium text-white">Install</Link>
                    </div>
                </div>
            </div>
            <header className='py-4 md:fixed relative top-0 w-full left-0 z-10 header'>
                <div className='container mx-auto md:px-5 px-3'>
                    <div className='flex items-center xl:gap-10 gap-6 justify-between'>
                        <div>
                            <Link to="/"><img src='/assets/images/logo.svg' className='md:w-40 w-28' /></Link>
                        </div>
                        <div className=' hidden md:block'>
                            <div className='flex justify-center xl:gap-8 gap-4 uppercase text-sm'>
                                <Link to="/" className="hover:text-[#B3902D] transition-all">Home</Link>
                                {isLoggedIn ? (
                                    <Link to="/listing" className="hover:text-[#B3902D] transition-all">Sell Your Jewelry</Link>
                                ) : (
                                    <Link to="/register" className="hover:text-[#B3902D] transition-all">Sell Your Jewelry</Link>
                                )}
                                <Link to="/gold-price" className="hover:text-[#B3902D] transition-all">Gold Prices</Link>
                                <Link to="/silver-price" className="hover:text-[#B3902D] transition-all">Silver Prices</Link>
                                <Link to="/contact" className="hover:text-[#B3902D] transition-all">Contact Us</Link>
                            </div>
                        </div>
                        <div className='md:text-sm text-xs flex items-center gap-2'>
                            {isLoggedIn ? (
                                <>
                                    <Link
                                        to="/dashboard"
                                        className="uppercase rounded-full border-2 border-[#B3902D] py-3 xl:px-5 px-4 hover:bg-[#B3902D] hover:text-white inline-block transition-all mr-2"
                                    >
                                        <i className="fa-solid fa-user-tie mr-2"></i> My Account
                                    </Link>
                                    <button
                                        onClick={handleLogout}
                                        className="uppercase rounded-full border-2 border-[#B3902D] py-3 xl:px-5 px-4 hover:bg-[#B3902D] hover:text-white inline-block transition-all"
                                    >
                                        <i className="fa-solid fa-user-tie mr-2"></i> Logout
                                    </button>
                                </>

                            ) : (
                                <Link
                                    to="/login"
                                    className="uppercase rounded-full border-2 border-[#B3902D] py-3 xl:px-5 px-4 hover:bg-[#B3902D] hover:text-white inline-block transition-all"
                                >
                                    <i className="fa-solid fa-user-tie mr-2"></i> Login / Sign up
                                </Link>
                            )}
                            <button
                                onClick={() => setIsOpen(!isOpen)}
                                className="bg-[#B3902D] inline-flex items-center justify-center p-2 rounded-full text-white hover:bg-[#262626] focus:outline-none md:hidden"
                                aria-expanded="false">
                                <span className="sr-only">Open main menu</span>
                                {!isOpen ? (
                                    <svg
                                        className="block h-6 w-6"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                        aria-hidden="true"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth="2"
                                            d="M4 6h16M4 12h16m-7 6h7"
                                        />
                                    </svg>
                                ) : (
                                    <svg
                                        className="block h-6 w-6"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                        aria-hidden="true"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth="2"
                                            d="M6 18L18 6M6 6l12 12"
                                        />
                                    </svg>
                                )}
                            </button>
                        </div>
                    </div>
                </div>
                <div className={`md:hidden absolute top-[80px] p-2 bg-[#FBF8F1] w-full z-50 ${isOpen ? 'block' : 'hidden'}`}>
                    <Link to="/" className="hover:text-[#B3902D] transition-all block p-2">Home</Link>
                    {isLoggedIn ? (
                        <Link to="/listing" className="hover:text-[#B3902D] transition-all block p-2">Sell Your Jewelry</Link>
                    ) : (
                        <Link to="/register" className="hover:text-[#B3902D] transition-all block p-2">Sell Your Jewelry</Link>
                    )}
                    <Link to="/gold-price" className="hover:text-[#B3902D] transition-all block p-2">Gold Prices</Link>
                    <Link to="/silver-price" className="hover:text-[#B3902D] transition-all block p-2">Silver Prices</Link>
                    <Link to="/contact" className="hover:text-[#B3902D] transition-all block p-2">Contact Us</Link>
                </div>
            </header>

        </>
    )
}

Header.propType = {
    home: PropTypes.string,
    aboutText: PropTypes.number
}
